<div class="footer-container">
    <mat-grid-list cols="3" rowHeight="64px">
        <mat-grid-tile>
            
        </mat-grid-tile>

        <mat-grid-tile></mat-grid-tile>
        <mat-grid-tile></mat-grid-tile>
    </mat-grid-list>
</div>